<template>
    <div>
        <button
            type="button"
            @click="open = !open"
            class="mt-1 group w-full flex items-center pl-2 pr-1 py-2 text-sm leading-5 font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700 transition ease-in-out duration-150"
        >
            <slot name="button"></slot>
            <!-- Expanded: "text-gray-400 rotate-90", Collapsed: "text-gray-300" -->
            <svg
                :class="open ? 'text-gray-400 rotate-90' : 'text-gray-300'"
                class="ml-auto h-5 w-5 group-hover:text-gray-400 group-focus:text-gray-400 transform transition-transform ease-in-out duration-150"
                viewBox="0 0 20 20"
            >
                <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
            </svg>
        </button>
        <!-- Expandable link section, show/hide based on state. -->
        <div class="mt-1 space-y-1" v-show="open">
            <slot name="items"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        };
    },
    methods: {
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
